import { React } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import { useGetPaginatedWorkshopsMutation } from '../../../store/api/endpoints/workhopsApiSlice'

import HeaderVista from '../../elementos/HeaderVista'
import TablaPaginadaNew from '../../elementos/TablaPaginadaNew'


import Button from '@mui/material/Button'
import { Breadcrumbs, Typography } from '@mui/material'

import AddIcon from '@mui/icons-material/Add'
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo'
import CreateIcon from '@mui/icons-material/Create'
import DeleteIcon from '@mui/icons-material/Delete'

export default function Workshops() {

    const thead = []
    thead.push({ label: "Imagen", align: "center", ordenable: false })
    thead.push({ label: "Publicación", align: "center", ordenable: true })
    thead.push({ label: "Título", align: "left", ordenable: true })
    thead.push({ label: "Speaker", align: "left", ordenable: true })
    thead.push({ label: "Acciones", align: "center", ordenable: false })

    const tbody = []
    tbody.push({ tipo: "img", valor: "previewImage" })
    tbody.push({ tipo: "fecha", valor: "publicationDate" })
    tbody.push({ tipo: "texto", valor: "title" })
    tbody.push({ tipo: "texto", valor: "speaker" })
    let botones = []
    botones.push({ color: "primary", icono: <CreateIcon />, ruta: "/workshops/editar/", valor: '_id' })
    botones.push({ color: "error", icono: <DeleteIcon />, ruta: "/workshops/eliminar/", valor: '_id' })
    tbody.push({ tipo: "botones", valor: botones })


    return (
        <>
            <HeaderVista
                titulo={
                    <Breadcrumbs aria-label="breadcrumb">
                        <Typography color="text.primary">Workshops</Typography>
                    </Breadcrumbs>
                }
                icon={<OndemandVideoIcon />}
                end={<Link to="/workshops/crear">
                    <Button
                        variant="outlined"
                        size="small"
                        startIcon={<AddIcon />}
                    >
                        Nuevo
                    </Button>
                </Link>}
            />
            <TablaPaginadaNew
                api={useGetPaginatedWorkshopsMutation}
                thead={thead}
                tbody={tbody}
                orderByDefault="publicationDate"
                orderAsDefault="-1"
            />
        </>
    )

}